import { Paper } from "@material-ui/core";
import MaterialTable from "material-table";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FiEdit, FiFile, FiTrash2 } from "react-icons/fi";
import { Link, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import {
  ErrorUnexpected,
  OperationSuccessfully,
} from "../../../../../../const/Messages";
import * as ArticleService from "../../../../../../service/DocumentArticleService";
import { ReviewModal } from "./ReviewModal";

export default function ArticleList() {
  const history = useHistory();
  const [data, setData] = useState([]);
  const [modalState, setModalState] = useState({ open: false, id: null });

  useEffect(() => {
    ArticleService.findAll()
      .then((data) => {
        setData(data);
      })
      .catch(() => {
        toast.error(ErrorUnexpected);
      });
  }, []); // eslint-disable-line

  const handleClose = () => {
    setModalState({ open: false, id: null }); // Reseta o estado para fechar o modal de review
  };

  function handleDelete(id) {
    Swal.fire({
      icon: "warning",
      title: "Confirmation",
      text: "Are you sure you want to delete?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      closeOnConfirm: true,
    }).then((result) => {
      if (result.isConfirmed) {
        ArticleService.deleteById(id)
          .then(() => {
            ArticleService.findAll()
              .then((data) => {
                setData(data);
                toast.success(OperationSuccessfully);
              })
              .catch(() => {
                toast.error(ErrorUnexpected);
              });
          })
          .catch(() => {
            toast.error(ErrorUnexpected);
          });
      }
    });
  }

  const columns = [
    {
      title: "Title",
      field: "title",
      defaultSort: "asc",
    },
    {
      title: "PIN",
      field: "pin",
      render: (obj) => (obj.pin ? "YES" : "NO"),
    },
    {
      title: "Section",
      field: "sectionTitle",
    },
  ];

  return (
    <Row>
      <Col>
        <div className="ibox">
          <div className="ibox-title d-flex justify-content-between align-items-center">
            <h5>Article - List</h5>
            <div>
              <Link
                className="btn btn-primary"
                to={{
                  pathname: "/settings/document/article/reg",
                  state: { id: "" },
                }}
              >
                New Article
              </Link>
            </div>
          </div>
          <div className="ibox-content">
            <MaterialTable
              title=""
              columns={columns}
              data={data}
              components={{
                Container: (props) => <Paper {...props} elevation={0} />,
              }}
              options={{
                sorting: true,
                pageSize: 10,
                pageSizeOptions: [5, 10, 15, 20],
                actionsColumnIndex: -1,
                exportButton: true,
                exportAllData: true,
                searchFieldAlignment: "left",
                toolbarButtonAlignment: "right",
                exportFileName: "article",
                headerStyle: {
                  textTransform: "uppercase",
                },
              }}
              actions={[
                {
                  icon: () => <FiEdit size={16} color="#007bff" />,
                  tooltip: "EDIT",
                  onClick: (event, rowData) =>
                    history.push("/settings/document/article/reg", {
                      id: rowData.id,
                    }),
                },
                {
                  icon: () => <FiTrash2 size={16} color="#007bff" />,
                  tooltip: "DELETE",
                  onClick: (event, rowData) => handleDelete(rowData.id),
                },
                {
                  icon: () => <FiFile size={16} color="#007bff" />,
                  tooltip: "Revisions",
                  onClick: (event, rowData) => {
                    if (rowData && rowData.id) {
                      setModalState({ open: true, id: rowData.id });
                    } else {
                      toast.error("No article found.");
                    }
                  },
                },
              ]}
            />
          </div>
        </div>
      </Col>
      <ReviewModal
        open={modalState.open}
        handleClose={handleClose}
        id={modalState.id}
      />
    </Row>
  );
}
